import { render, staticRenderFns } from "./SapLoad.vue?vue&type=template&id=60847a7e&scoped=true"
import script from "./SapLoad.vue?vue&type=script&lang=js"
export * from "./SapLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60847a7e",
  null
  
)

export default component.exports